module.exports = __webpack_public_path__ + "img/zip.7ead45a1.svg";